"use client";
import Skeleton from "react-loading-skeleton";

const renderSkeleton = (
  skeletonHeight = null,
  skeletonWidth = null,
  skeletonStyle = {}
) => {
  const hasDimensions = skeletonHeight || skeletonWidth;
  const skeletonEl = (
    <Skeleton
      {...(skeletonHeight ? { height: skeletonHeight } : {})}
      {...(skeletonWidth ? { width: skeletonWidth } : {})}
      style={skeletonStyle}
    />
  );

  if (!hasDimensions) {
    return <div style={skeletonStyle}>{skeletonEl}</div>;
  }

  return skeletonEl;
};

export default renderSkeleton;
